import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';
import {ErrorsFromBE, takeLatestF} from 'favorlogic-utils';

import {handleResponseError} from 'utils/handleResponseError';

import {loadLaborersError, loadLaborersSuccess} from '../actions';
import Api from '../api';

function* execute(): SagaIterator {
    const errorTitle = 'Načtení laborantů';
    const response = yield* call(Api.getLaborers);

    if (!response.isSuccess) {
        const error = response.data as ErrorsFromBE;
        yield* call(handleResponseError, response, errorTitle);
        return yield* put(loadLaborersError(error));
    }

    yield* put(loadLaborersSuccess(response.data));
}

export function* loadLaborersSaga(): SagaIterator {
    yield takeLatestF('user/LOAD_LABORERS', execute);
}
